<apt-template-nested-state state="info" title="ACCESS DENIED">
  <ng-container message>
    <p>{{ 'Access.accessDenied' | translate }}</p>
  </ng-container>
</apt-template-nested-state>
